import React from "react";
import HeaderComp from "../components/HeaderComp";
import InternMenu from "../components/InternMenu";
import FooterCompo from "../components/FooterCompo";
import LandingPageScreen from "../screens/landingpagescreens/LandingPageScreen";
import { Route, Switch } from "react-router-dom";
import Propiedades from "../screens/propiedadesscreens/Propiedades";
import DetallePropiedad from "../screens/propiedadesscreens/DetallePropiedad";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import API, { mainIp } from "../API/API";
import { ItemDescription } from "../../node_modules/semantic-ui-react";
import MetaTagComp from "../components/MetaTagComp";

const typeDevelopmentSelector = [
  {
    key: "home",
    value: "home",
    text: "Casas"
  },
  {
    key: "department",
    value: "department",
    text: "Departamentos"
  },
  {
    key: "department&home",
    value: "department&home",
    text: "Casas y Departamentos"
  }
];

class LandingPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { dataSet: {}, targetTitle: "", modelId: '' };
    this.historyListener = null;
    this.renderHeading = this.renderHeading.bind(this);
  }

  renderHeading() {
    let params = window.location.pathname;
    params =
      params.lastIndexOf("/") == params.length - 1
        ? params.substr(0, params.length - 1)
        : params.substr(0, params.length + 1);
    const targetValue = params.substr(params.lastIndexOf("/") + 1);

    if (targetValue === "propiedades") {
      this.setState({ targetTitle: "Propiedades", modelId: '' });
    } else if (targetValue === this.props.url) {
      this.setState({ targetTitle: this.state.dataSet.name, modelId: '' });
    } else if (targetValue !== "") {
      
      let developmentId = this.state.dataSet.id;

      const propertieFind = this.props.developmentProperties.find(
        propertieTemp => {
          return propertieTemp.url === targetValue && developmentId === propertieTemp.developmentId;
        }
      );
      if (propertieFind !== undefined) {
        if (propertieFind.name !== undefined) {
          this.setState({ targetTitle: propertieFind.name, modelId: propertieFind.id});
        }
      }
    }
  }

  componentDidMount() {
    this.historyListener = this.props.history.listen((location, action) => {
      this.renderHeading();
    });
  }

  componentWillUnmount() {
    if (this.historyListener !== null) {
      this.historyListener();
    }
  }

  componentWillMount() {
    const api = new API();
    let dataSet = {};
    const pathData = this.props.location.pathname;
    const developmentFromURL = this.props.developments.find(checkState => {
      return pathData.trim().includes("/" + checkState.url.trim());
    });
    if (developmentFromURL !== undefined) {
      dataSet = developmentFromURL;
      api.getDevelopment(dataSet.id).then(response => {
        dataSet = response[0];
        let typeOfProperties = "";
        const foundTypeOfProperties = typeDevelopmentSelector.find(
          typeOfProperties => {
            return typeOfProperties.value === dataSet.typeOfProperties;
          }
        );
        if (foundTypeOfProperties !== undefined) {
          typeOfProperties = foundTypeOfProperties.text;
        }
        dataSet.typeOfProperties = typeOfProperties;
        this.setState({ dataSet: dataSet });
        this.renderHeading();
      });
    }
  }

  render() {
    let headerimg = "";
    let logo = "";
    if (this.state.dataSet.headerImage !== undefined) {
      headerimg = mainIp + this.state.dataSet.headerImage.result;
    }

    if (this.state.dataSet.logo !== undefined) {
      logo = mainIp + this.state.dataSet.logo.result;
    }

    return (
      <div>
        {this.state.dataSet.name !== undefined && (
          <MetaTagComp
            section={"home"}
            replaceMetaTags={[
              {
                name: "title",
                content: "Dream Lagoons | " + this.state.dataSet.name
              },
              {
                name: "description",
                content: this.state.dataSet.description
              }
            ]}
          />
        )}
        <HeaderComp
          headerImg={headerimg}
          title={this.state.targetTitle}
          logo={logo}
        />
        <InternMenu url={"/" + this.props.url} currentModel={this.state.modelId}/>
        <Switch>
          <Route exact path={"/" + this.props.url + "/"}>
            <LandingPageScreen data={this.state.dataSet} url={this.props.url} />
          </Route>
          <Route path={"/" + this.props.url + "/propiedades"}>
            <Propiedades
              url={"/" + this.props.url}
              data={this.state.dataSet.developmentProperties || []}
            />
          </Route>
          <Route path={"/" + this.props.url + "/detalle/:id"}>
            <DetallePropiedad
              development={this.state.dataSet}
              data={this.state.dataSet.developmentProperties || []}
            />
          </Route>
        </Switch>
        <FooterCompo />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    push: to => {
      dispatch(push(to));
    }
  };
};

const mapStateToProps = ({ data }) => {
  const { pages, currentlanguage, developments, developmentProperties } = data;
  return {
    pages,
    currentlanguage,
    developments,
    developmentProperties
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LandingPage)
);
